import ElectricFailMutations from "./ElectricFailMutations";
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import ElectricFailActions from "./ElectricFailActions";

const state = {
	status:                     FetchStatus.Init,
	successMessage:             "",
	errorMessage:               "",
	operatingRange:             0,
	rawOrderChartData:          [],
	rawFrequencyChartData:      [],
	envelopeOrderChartData:     [],
	envelopeFrequencyChartData: [],
	orderLayout:                [],
	frequencyLayout:            [],
	signalSettingIds:           [],
};

const { actions } = ElectricFailActions;

const { mutations } = ElectricFailMutations;

const namespaced = true;

export default {
	state,
	actions,
	mutations,
	namespaced,
};
